export const UNLOADED = 0;
export const LOADING = 1;
export const LOADED = 4;
